import { GetContractResponse } from '@/api/generated/engageUIApiEndpoints.schemas'
import { CustomerMasterData } from '@/domain/contract/types/customer'

export const mapToCustomerMasterData = (resource: GetContractResponse): CustomerMasterData => {
  const legacyProfileIdOfContract = resource.customer?.ownedChargingContracts.find(
    (contract) => contract.contractReference.contractId === resource.contract.id
  )?.legacyProfileId
  const device = resource.identity?.mobileDevices
    .filter((device) => device.selectedLegacyProfileId === legacyProfileIdOfContract)
    .sort((a, b) => new Date(b.lastUsedAt).getTime() - new Date(a.lastUsedAt).getTime())[0]
  return {
    keyFigures: {
      mobilityPlusId: resource.identity?.id,
      authSubject: resource.identity?.myEnergyKey.subject
    },
    contractCounts: {
      activeContracts: resource.contractCounts.activeContracts,
      contractsInTermination: resource.contractCounts.contractsInTermination,
      terminatedContracts: resource.contractCounts.terminatedContracts
    },
    fleetMembershipCounts: {
      activeMemberships: resource.contractCounts.activeFleetMemberships,
      previousMemberships: resource.contractCounts.previousFleetMemberships
    },
    deviceData: {
      createdAt: device?.createdAt ? new Date(device?.createdAt) : undefined,
      lastUsedAt: device?.lastUsedAt ? new Date(device?.lastUsedAt) : undefined,
      osName: device?.platform,
      osVersion: device?.clientOsVersion,
      deviceName: device?.deviceModel,
      appVersion: device?.appVersion
    }
  }
}
